import { Injectable } from "@angular/core";
import { HttpService } from "./utils/http.service";
import { IDocumentModel, ICustomerSiteLogChecklistModel, ICustomerSiteLogModel } from "../models";

@Injectable()
export class CustomerSiteLogService {
	constructor(private httpService: HttpService) { }

	async getCustomerSiteLog(customerId: number): Promise<ICustomerSiteLogModel> {
		return await this.httpService.get(`/customerSiteLog/getCustomerSiteLog?customerId=${customerId}`);
	}

	async saveCustomerSiteLog(customerId: number, model: ICustomerSiteLogModel): Promise<ICustomerSiteLogModel> {
		return await this.httpService.post(`/customerSiteLog/saveCustomerSiteLog?customerId=${customerId}`, model);
	}

	async getSiteLogChecklist(customerId: number, jobId: number, appointmentId: number): Promise<ICustomerSiteLogChecklistModel> {
		return await this.httpService.get(
			`/customerSiteLog/getSiteLogChecklist?customerId=${customerId}&jobId=${jobId}&appointmentId=${appointmentId}`);
	}

	async saveSiteLogChecklist(customerId: number, jobId: number, appointmentId: number, model: ICustomerSiteLogChecklistModel): Promise<ICustomerSiteLogChecklistModel> {
		return await this.httpService.post(
			`/customerSiteLog/saveSiteLogChecklist?customerId=${customerId}&jobId=${jobId}&appointmentId=${appointmentId}`, model);
	}

	async getSiteLogAssetPhotos(jobId: number, customerDocumentKey: string, assetDocumentKey: string, photoType: string): Promise<IDocumentModel[]> {
		return await this.httpService.get("/customerSiteLog/getSiteLogAssetPhotos", {
			jobId,
			customerDocumentKey,
			assetDocumentKey,
			photoType
		});
	}

	async generateSiteLogPdf(customerId: number, jobId: number): Promise<string> {
		return await this.httpService.post(`/customerSiteLog/generateSiteLogPdf?customerId=${customerId}&jobId=${jobId}`, null);
	}

	async saveSiteLogAssetPhotos(jobId: number, customerDocumentKey: string, assetDocumentKey: string, photoType: string, fileModels: IDocumentModel[]): Promise<IDocumentModel[]> {
		const formData = new FormData();
		fileModels.forEach(file => {
			formData.append("file", file.file, file.file.name);
		});

		return await this.httpService.postMultipart(
			`/customerSiteLog/saveSiteLogAssetPhotos?jobId=${jobId}&customerDocumentKey=${customerDocumentKey}&assetDocumentKey=${assetDocumentKey}&photoType=${photoType}`,
			formData);
	}
}
